import api from "../../config/client.axios.api";

export const loginWithSocialApiRequest = async (accessToken: string) => {
  const response = await api.post(
    `/auth/social-authenticate?accessToken=${accessToken}`
  );
  return response.data;
};
